import { render, staticRenderFns } from "./safemanage.vue?vue&type=template&id=6a615b86&scoped=true&"
import script from "./safemanage.vue?vue&type=script&lang=js&"
export * from "./safemanage.vue?vue&type=script&lang=js&"
import style0 from "./safemanage.vue?vue&type=style&index=0&id=6a615b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a615b86",
  null
  
)

export default component.exports